module.exports = __webpack_public_path__ + "img/02030213.edc57ecb.svg";